var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2752 9.00198C18.2752 11.4751 17.2385 13.869 15.4381 15.5625C13.7762 17.1216 11.5405 17.996 9.27322 18C7.00592 17.996 4.77025 17.1216 3.10834 15.5625C1.30795 13.869 0.27124 11.4751 0.27124 9.00198C0.27124 6.22422 1.52557 3.6443 3.7098 1.92306C4.41412 1.36908 5.47063 1.62233 5.89796 2.38205C6.25805 3.01913 6.09581 3.81841 5.51415 4.28139C4.06987 5.43284 3.23893 7.15409 3.23893 9.00198C3.23893 10.6678 3.90368 12.2229 5.11054 13.3704C6.24617 14.4546 7.7142 15.0363 9.27322 15.0363C10.8322 15.0363 12.3003 14.4546 13.4359 13.3704C14.6428 12.2229 15.3075 10.6678 15.3075 9.00198C15.3075 7.15409 14.4766 5.43284 13.0323 4.28139C12.4506 3.81841 12.2884 3.01913 12.6485 2.38205C13.0758 1.62233 14.1323 1.36908 14.8366 1.92306C17.0209 3.6443 18.2752 6.22422 18.2752 9.00198Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27322 8.50737C10.0913 8.50737 10.7571 7.84176 10.7571 7.02352V1.48384C10.7571 0.665604 10.0913 0 9.27322 0C8.45518 0 7.78938 0.665604 7.78938 1.48384V7.02352C7.78938 7.84176 8.45518 8.50737 9.27322 8.50737Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.2ec9fd226f178926dc45aac6d4247c0e.svg";
export { ForwardRef as ReactComponent };